module.exports = __webpack_public_path__ + "img/Asian Quinoa Bowl-Tofu.4c5f0ec0.jpg";